import { resolveColor } from 'constants/colors';
import { COLOR_PALETTE } from 'constants/ui';
import { checkIsGuid } from 'utils/data';

/**
 * Convert the multi-value Links-tab form to the PUT /api/documents/{id}/associations body.
 *
 * The backend (Skynet.Documents #393) accepts the collection-contract shape.
 *
 * @param {{ borrowers: object[], incomes: object[], assets: object[], properties: object[], liabilities: object[] }} form
 * @returns {{ borrowerIds: string[], incomeIds: string[], assetIds: string[], propertyIds: string[], liabilityIds: string[] }}
 */
export const getLinksFieldsToSend = form => ({
  borrowerIds: (form.borrowers ?? []).map(o => o.value),
  incomeIds: (form.incomes ?? []).map(o => o.value),
  assetIds: (form.assets ?? []).map(o => o.value),
  propertyIds: (form.properties ?? []).map(o => o.value),
  liabilityIds: (form.liabilities ?? []).map(o => o.value),
});

/**
 * Resolve a SYSTEM_COLORS palette entry to a { bg, fg } pair.
 * Falls back to neutral grey tones when the name is not found.
 *
 * @param {string} colorName - A SYSTEM_COLORS name (e.g. 'Azure', 'Fern').
 * @returns {{ bg: string, fg: string }}
 */
export const resolveEntityColor = colorName => {
  const entry = resolveColor(colorName);

  if (entry) {
    return { bg: entry.bg, fg: entry.fg };
  }

  return { bg: COLOR_PALETTE.GRAY[4], fg: COLOR_PALETTE.GRAY[8] };
};

/**
 * The task a document was submitted to counts as one link (documents carry it as metadata `TaskId`).
 * The id is free-form document metadata, so only a GUID counts and is ever sent to the task API.
 *
 * @param {string|null|undefined} taskId - The document's `TaskId`.
 * @returns {number}
 */
export const getTaskLinkCount = taskId => (checkIsGuid(taskId) ? 1 : 0);
